import { Router, Switch, Route, Redirect } from 'react-router-dom';

import StartPage from './pages/StartPage';
import SearchPage from './pages/searchPage';
import ProductInfo from './pages/ProductInfo';
import ShoppingCart from './pages/ShoppingCart';
import Container from './pages/Container';

import React from 'react';

export interface ReactRouterProps {
  apiData: any;
  mode: string;
  renderingUrl: string;
  postRenderControl?: any;
}

interface ReactRouterState {
  mode: string;
  apiUrl: string;
}

export default class ReactRouter extends React.Component<
  ReactRouterProps,
  ReactRouterState
> {
  constructor(props: any) {
    super(props);

    this.state = { mode: props.mode, apiUrl: props.apiData.domainPrefix };
  }

  componentDidMount() {
    if (this.state.mode != 'react')
      setTimeout(() => {
        this.setState({ mode: 'react' });
      }, 1000);
  }

  getDynamicParams(props: any) {
    let apiData = null;

    if (this.state.mode == 'ssr' || this.state.mode == 'hydrate') {
      apiData = this.props.apiData;
    }

    let dynProps = {
      ...props,
      apiData: apiData,
      apiUrl: this.state.apiUrl,
      mode: this.state.mode,
      renderingUrl: this.props.renderingUrl,
      postRenderControl: this.props.postRenderControl,
    };
    return dynProps;
  }

  render() {
    let pageItem = (
      <Switch>
        <Route
          exact
          path="/"
          render={(props) => {
            return <StartPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/product_info/:products_id"
          render={(props) => {
            return <ProductInfo {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/search_page/"
          render={(props) => {
            return <SearchPage {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/shopping_cart/"
          render={(props) => {
            return <ShoppingCart {...this.getDynamicParams(props)} />;
          }}
        />
        <Route
          path="/container/"
          render={(props) => {
            return <Container {...this.getDynamicParams(props)} />;
          }}
        />

        <Route
          path="/check"
          render={(props) => {
            return <div>OK</div>;
          }}
        />
      </Switch>
    );

    return pageItem;
  }
}

//const ReactRouter = () => {};
